import { inject } from '@angular/core';
import { signalStore, withFeature, withState } from '@ngrx/signals';
import { requestFeature } from '../../../../shared/signal-store';
import { MetricGroupService } from './metric-group.service';

export const MetricGroupStore = signalStore(
  withState((_service = inject(MetricGroupService)) => ({ _service })),
  withFeature((store) => requestFeature(store._service(), 60 * 60 * 1000, { withCache: true, storeName: 'metric-groups' }))
);
